import { render, staticRenderFns } from "./PdpDescriptionTab.vue?vue&type=template&id=4561c94c&scoped=true"
import script from "./PdpDescriptionTab.vue?vue&type=script&lang=js"
export * from "./PdpDescriptionTab.vue?vue&type=script&lang=js"
import style0 from "./PdpDescriptionTab.vue?vue&type=style&index=0&id=4561c94c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4561c94c",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fpdp-description-tab%2FPdpDescriptionTab.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports